jQuery.noConflict();
(function( $ ) {
    $(function() {
        //Document Ready STARTS

        // VideoJS Continue watching START

         //  var html = '<div class="continue-watching vj">Continue watching from where you left <button class="button videojs-continue" data-time="'+progress+'" data-id="'+id+'" data-file="'+label+'">Continue watching</button> <button class="button close-button" title="Close"><span class="icon-cancel"></span></button></div>';
        //    $('#'+id).append(html);
        // progress = localStorage.getItem(label);
        //localStorage.setItem('sc_vj_'+eventLabel, currentTime);

        if ($('.vimeo-player').length>0) {
            scVimeoTracking();
        }

        $('body').on('click', '.continue-watching  .close-button', function(){
            $(this).parent().remove();
        });

        $('body').on('click', '.continue-watching  .vimeo-continue', function(){
            var id = $(this).attr('data-id'),
                time = $(this).attr('data-time');
            const iframe = document.querySelector('iframe.vimeo-player');
            const vimeoPlayer = new Vimeo.Player(iframe);
            vimeoPlayer.setCurrentTime(time);
            // vimeoPlayer.play();
            $('.continue-watching').remove();
        });
        // VideoJS Continue watching END

        //Document Ready ENDS
    });
})(jQuery);
var vimeoData = [];
function scVimeoTracking(){
    const iframe = document.querySelector('iframe.vimeo-player');
    const vimeoPlayer = new Vimeo.Player(iframe);
    vimeoPlayer.getVideoTitle().then(function(title) {
        vimeoData.vimeoTitle = title;
        vimeoData.slug = titleSlug(title);
        checkVimeoProgress();
        vimeoPlayer.on('timeupdate', function(data){
            localStorage.setItem(vimeoData.slug, data.seconds);
        });
        vimeoPlayer.on('pause', function(data){
            localStorage.setItem(vimeoData.slug, data.seconds);
        });
        vimeoPlayer.on('end', function(data){
            localStorage.removeItem(vimeoData.slug);
        });
    });
}

function titleSlug(text){
    text = text.toLowerCase();
    const regex = / /i;
    text = text.replace(regex, '_');
    return 'sc_vimeo_'+text;
}

function checkVimeoProgress(){
    var progress = localStorage.getItem(vimeoData.slug);
    if (progress != undefined && progress > 0) {
        var html = '<div class="continue-watching vimeo">Continue watching from where you left <button class="button vimeo-continue" data-time="'+progress+'" data-file="'+vimeoData.slug+'">Continue watching</button> <button class="button close-button" title="Close"><span class="icon-cancel"></span></button></div>';
        jQuery('.vimeo-player').parent().append(html);
    }
}

